module.exports = __webpack_public_path__ + "static/media/compliance.c75140ab.png";